import { Card } from "@cappelendamm/design-system/react";
import classNames from "classnames";

type FormCardProps = {
  children: React.ReactNode;
  className?: string;
};

export const FormCard = ({ children, className }: FormCardProps) => {
  return (
    <Card
      className={classNames(
        "flex flex-col divide-y overflow-visible bg-white p-4 [&>*]:py-4 [&>*:first-child]:pt-0 [&>*:last-child]:pb-0",
        className,
      )}
      as="div"
    >
      {children}
    </Card>
  );
};
